import AccountsInfo from './AccountsInfo';

export default AccountsInfo;
